import React, { useEffect, useState } from 'react'
import { Card, CardBody, CardHeader } from '../../../../_metronic/_partials/controls'
import Table, { dateFormatter, buttonsStyle } from '../../../components/tables/table'
import { getThehubs } from '../../../../api/thehub'
import { Button, Tooltip } from '@material-ui/core'
import EditIcon from '@material-ui/icons/Edit'
import { alertError } from '../../../../utils/logger'
import { useHistory } from 'react-router-dom'

function getData(thehubs) {
  let data = []
  for (let i = 0; i < thehubs.length; ++i) {
      const elem = {}
      elem.name = Object.values(thehubs[i].fullName)[0]
      elem.createdAt = thehubs[i].createdAt
      elem.id = thehubs[i]._id
      data = data.concat(elem)
  }
  return data
}

export default function ThehubsPage() {
  const [data, setData] = useState([])
  const [refresh, setRefresh] = useState(false)
  const history = useHistory()

  function buttonFormatter(cell) {
    return (<>
      <Tooltip title="Edit">
        <Button
          style={buttonsStyle} size="small"
          onClick={() => history.push('/edit-thehub/' + cell)}>
          <EditIcon/>
        </Button>
      </Tooltip>
    </>)
  }


  const columns = [
    { dataField: 'name', text: 'Full name', sort: true },
    { dataField: 'createdAt', text: 'Created at', formatter: dateFormatter, sort: true },
    { dataField: 'id', text: '', formatter: buttonFormatter }
  ]

  useEffect(() => {
    getThehubs().then((res) => {
      if (res.status === 200) {
        setData(getData(res.data))
        setRefresh(false)
      }
    }).catch(error => {
      alertError({ error: error, customMessage: 'Could not get thehubs.' })
    })
  }, [refresh])

  return (
    <>
      <Card>
        <CardHeader title='Thehubs list'>
        </CardHeader>
        <CardBody>
          <Table
            data={data}
            columns={columns}
          />
        </CardBody>
      </Card>
    </>
  );
}
